import { S3FileBrowser } from '@convergence/components';
import { FileBrowserSelectionType } from '@convergence/types';
import { FolderUserIcon } from '@phosphor-icons/react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { fetch } from '../../api/fetch';
import sharedFilesIcon from '../../assets/folder-users.svg';
import { HomeStore } from '../../stores/HomeStore';
import { TinkerBoxFileBrowser } from '../TinkerBoxFileBrowser';
import { ViewSelector } from '../ViewSelector';
import { LabSelector } from './LabSelector';
import { View, ViewType } from './SidePanel';
import { SidePanelShell } from './SidePanelShell';
import { TinkerBoxSection } from './TinkerBoxesSection';
import { useQueryClient } from '@tanstack/react-query';

export interface LabSidePanelProps {
  className?: string;
  setOpen: (visible: boolean) => void;
  open: boolean;
  tinkerBoxConnection: HomeStore['tinkerBoxConnection'];
  store: HomeStore;
}

export const LabSidePanel = observer(
  ({ store, open = true, setOpen, tinkerBoxConnection }: LabSidePanelProps) => {
    const [selectedView, setSelectedView] = useState<ViewType>('sharedFiles');

    const handleViewSelection = (selection: ViewType) => {
      setSelectedView(selection);
    };

    const queryClient = useQueryClient();
    const [path, setPath] = useState<string[]>([]);

    return (
      <SidePanelShell open={open} setOpen={setOpen}>
        {open && (
          <div className="p-4 pr-0 flex-col overflow-hidden h-full flex flex-1">
            <LabSelector store={store} />
            <div className="flex justify-around pb-2">
              <ViewSelector
                title="Shared Files"
                view={View.sharedFiles}
                isSelected={selectedView === 'sharedFiles'}
                handleViewSelection={handleViewSelection}
              >
                <img
                  src={sharedFilesIcon}
                  width={22}
                  height={22}
                  className="mx-auto"
                />
              </ViewSelector>
              <ViewSelector
                title="Tinkerbox Files"
                view={View.tinkerboxFiles}
                isSelected={selectedView === 'tinkerboxFiles'}
                handleViewSelection={handleViewSelection}
              >
                <FolderUserIcon size={22} className="mx-auto" />
              </ViewSelector>
            </div>
            <div className="h-full flex flex-col overflow-hidden">
              <div className="file-browser-container w-full h-3/5 overflow-hidden flex-shrink-0">
                {selectedView === 'sharedFiles' &&
                  store.selectedLab?.s3BucketId && (
                    <div className="h-full overflow-hidden">
                      <S3FileBrowser
                        className="h-full"
                        selectionMode={FileBrowserSelectionType.ALL}
                        readOnly={false}
                        s3BucketId={store.selectedLab.s3BucketId}
                        selection={[]}
                        fetch={fetch}
                        onSelectionChange={() => {}}
                        path={path}
                        setPath={setPath}
                        queryClient={queryClient}
                      />
                    </div>
                  )}
                {selectedView === 'tinkerboxFiles' && (
                  <div className="h-full overflow-hidden">
                    {store.tinkerBoxId ? (
                      <TinkerBoxFileBrowser store={tinkerBoxConnection} />
                    ) : (
                      <p className="py-2 italic text-neutral-600">
                        Connect to a tinkerbox to view its files
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div className="tinkerbox-container h-full overflow-hidden flex-grow pt-6">
                <TinkerBoxSection store={store} mode="lab" />
              </div>
            </div>
          </div>
        )}
      </SidePanelShell>
    );
  }
);
